<template>
  <div class="header-tabs text-large bolder">
    <span
      v-for="tab in tabs"
      class="tab pointer"
      :key="tab.id"
      :class="{ active: tab.id === selected }"
      @click="$emit('select', tab.id)"
      v-no-capture
    >
      {{ tab.label }}
    </span>
  </div>
</template>

<script>
/**
 * This component provides tabs.
 * This has been styled to used in headers
 * props:
 * - tabs: [{id: string, label: string}]
 * - selected (id of selected tab)
 */
export default {
  name: 'HeadingTabs',
  props: ['tabs', 'selected']
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.tab {
  border-bottom: 2px solid transparent;
  padding-bottom: 4px;
  color: $secondary;
}

.tab.active {
  border-bottom-color: $tertiary;
  color: $primary;
}

.tab:not(.active):hover {
  border-bottom-color: $borderPrimary;
  color: $primary;
}

.tab:not(:first-child) {
  margin-left: 8px;
}
@include media-breakpoint-down(md) {
  .tab {
    font-size: 1rem;
  }
}
</style>
